module.exports = __webpack_public_path__ + "884eaef172c18afde2418aa2c5be29e6.svg";


//////////////////
// WEBPACK FOOTER
// ./images/attachments-copy-notif.svg
// module id = 105
// module chunks = 0